'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_locales$002ecldr$002e$002dCalendar$002dPatterns from "./locales.cldr.-Calendar-Patterns.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns$() {
  $n_Llocales_cldr_CalendarPatterns$ = this;
  $m_Llocales_cldr_CalendarPatterns$();
}
export { $c_Llocales_cldr_CalendarPatterns$ as $c_Llocales_cldr_CalendarPatterns$ };
$p = $c_Llocales_cldr_CalendarPatterns$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_CalendarPatterns$;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns$() {
}
export { $h_Llocales_cldr_CalendarPatterns$ as $h_Llocales_cldr_CalendarPatterns$ };
$h_Llocales_cldr_CalendarPatterns$.prototype = $p;
$p.Ul = (function(x$0) {
  return new $j_locales$002ecldr$002e$002dCalendar$002dPatterns.$c_Llocales_cldr_CalendarPatterns(x$0.g(0), x$0.g(1));
});
$p.y = (function(p) {
  return this.Ul(p);
});
var $d_Llocales_cldr_CalendarPatterns$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_CalendarPatterns$, "locales.cldr.CalendarPatterns$", ({
  nC: 1,
  e: 1,
  g: 1
}));
export { $d_Llocales_cldr_CalendarPatterns$ as $d_Llocales_cldr_CalendarPatterns$ };
var $n_Llocales_cldr_CalendarPatterns$;
function $m_Llocales_cldr_CalendarPatterns$() {
  if ((!$n_Llocales_cldr_CalendarPatterns$)) {
    $n_Llocales_cldr_CalendarPatterns$ = new $c_Llocales_cldr_CalendarPatterns$();
  }
  return $n_Llocales_cldr_CalendarPatterns$;
}
export { $m_Llocales_cldr_CalendarPatterns$ as $m_Llocales_cldr_CalendarPatterns$ };
